module.exports = __webpack_public_path__ + "static/media/et.7873c0f7.svg";